import React, { useState } from 'react'
import _ from 'lodash'
import { Card, Button, Typography, Avatar, Table } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import moment from 'moment'
import PreviewImage from '../../components/PreviewImage'
import {
  getPoDeliverById
} from '../../modules/heroGroupSelling'
import Lightbox from "react-image-lightbox";
import "../../../node_modules/react-image-lightbox/style.css";
const { Text } = Typography;

const HeroPODView = (props) => {
  const dispatch = useDispatch()
  const { visible, onCancel, poDeliverId } = props
  const [visiblePreview, setVisiblePreview] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [photoIndex, setPhotoIndex] = useState(0)
  const [previewImage, setPreviewImage] = useState(null)
  const { poDeliverObj } = useSelector(
    (state) => ({
      poDeliverObj: state.heroGroupSelling.poDeliverObj
    }),
    []
  )

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(getPoDeliverById(poDeliverId))
    }
    fetch()
  }, [])

  const net_weight = poDeliverObj.deduction ? poDeliverObj.amountReceive - poDeliverObj.deduction : poDeliverObj.amountReceive ? poDeliverObj.amountReceive : 0
  const price = poDeliverObj.actualPrice ? poDeliverObj.actualPrice : 0
  const amount_money = net_weight * price
  const net_amount = poDeliverObj.fine ? amount_money - poDeliverObj.fine : amount_money

  const dataSource = [
    {
      name: 'รูปภาพส่งสินค้า',
      data: poDeliverObj.imageList ? poDeliverObj.imageList.length ? poDeliverObj.imageList : null : null,
    },
    {
      name: 'รูปรถพร้อมน้ำหนัก',
      data: poDeliverObj.carSendPic,
    },
    {
      name: 'หลักฐานน้ำหนัก',
      data: poDeliverObj.billSendPic,
    },
    {
      name: 'รูปการรับสินค้า',
      data: poDeliverObj.carArrivalPic,
    },
    {
      name: 'หลักฐานน้ำหนักรับ',
      data: poDeliverObj.billArrivalPic,
    },
    {
      name: 'ใบเสร็จ/ใบกำกับภาษี',
      data: poDeliverObj.taxPic,
    },
    {
      name: 'หลักฐานการโอน',
      data: poDeliverObj.paymentPic,
    },

  ];

  const columns = [
    {
      title: 'เอกสาร',
      dataIndex: 'name',
      key: 'name',
    },
    {
      dataIndex: 'data',
      key: 'data',
      align: 'right',
      render: (data, record) => <span>{data ? record.name == "รูปภาพส่งสินค้า" ?
        <div>
          <a
            onClick={() => {
              setIsOpen(true)
            }}>
            View
          </a>
          {isOpen && (
            <Lightbox
              mainSrc={data[photoIndex]}
              nextSrc={data[(photoIndex + 1) % data.length]}
              prevSrc={data[(photoIndex + data.length - 1) % data.length]}
              onCloseRequest={() => {
                setIsOpen(false)
              }}
              onMovePrevRequest={() => {
                setPhotoIndex((photoIndex + data.length - 1) % data.length)
              }}
              onMoveNextRequest={() => {
                setPhotoIndex((photoIndex + 1) % data.length)
              }}
            />
          )}
        </div>
        : data.match(/\.pdf$/) ? (
          <a href={data} target="_blank">
            View
          </a>
        ) : (<a
          onClick={() => {
            setVisiblePreview(true)
            setPreviewImage(data)
          }}>
          View
        </a>) : 'ไม่มีเอกสาร'}</span>
    }
  ];

  return (
    <Card
      destroyOnClose={true}
      title={'รายละเอียด POD'}
      visible={visible}
      extra={
        <div>
          <Button size="small" icon="close" onClick={() => onCancel()}>
            close
          </Button>
        </div>
      }>
      <Card title="ส่ง"
        extra={
          <div>
            <strong>ทะเบียนรถ: </strong> {poDeliverObj.truckResponse ? poDeliverObj.truckResponse.firstLicense + ' - ' + poDeliverObj.truckResponse.lastLicense + ' ' + poDeliverObj.truckResponse.province : ''} <br />
          </div>
        }
      >
        <strong>วันที่ส่ง: </strong> {poDeliverObj.sendDate ? moment(poDeliverObj.sendDate).format('DD/MM/YYYY') : ''}<br />
        <strong>วัสดุที่ส่ง: </strong>
        <span>
          <Avatar
            src={poDeliverObj.heroPoResponse ? poDeliverObj.heroPoResponse.materialImage : ''}
            size={35}
            style={{ marginRight: 5 }}
          />
          {poDeliverObj.heroPoResponse ? poDeliverObj.heroPoResponse.materialName : ''}
        </span><br />
        <strong>ส่งสินค้าให้: </strong> {poDeliverObj.heroPoResponse ? poDeliverObj.heroPoResponse.heroName : ''} <br />
        <strong>ปริมาณส่ง: </strong> {poDeliverObj.amountSent ? poDeliverObj.amountSent : '-'}<br />
        <strong>ราคาที่คาดหวัง: </strong> {poDeliverObj.heroPoResponse ? poDeliverObj.heroPoResponse.price : '-'}<br />
      </Card>
      <div><br></br></div>
      <Card title="ถึง">
        <strong>วันที่ถึง: </strong> {poDeliverObj.arrivalDate ? moment(poDeliverObj.arrivalDate).format('DD/MM/YYYY') : '-'}<br />
        <Text type="danger"><strong>น้ำหนักรับ: </strong> {poDeliverObj.amountReceive ? poDeliverObj.amountReceive + ' กิโลกรัม' : 0 + ' กิโลกรัม'}</Text><br />
        <strong>หัก: </strong> {poDeliverObj.deduction ? poDeliverObj.deduction + ' กิโลกรัม' : 0 + ' กิโลกรัม'}<br />
        <strong>น้ำหนักสุทธิ: </strong> {net_weight + ' กิโลกรัม'}<br />
        <strong>ราคา: </strong> {poDeliverObj.actualPrice ? poDeliverObj.actualPrice + ' บาท' : 0 + ' บาท'}<br />
        <strong>จำนวนเงิน: </strong> {amount_money + ' บาท'}<br />
        <Text type="danger"><strong>หักเงิน: </strong>{poDeliverObj.fine ? poDeliverObj.fine + ' บาท' : 0 + ' บาท'}</Text><br />
        <strong>จำนวนเงินสุทธิ: </strong> {net_amount + ' บาท'}<br />
      </Card>
      <div><br></br></div>
      <Table
        dataSource={dataSource}
        columns={columns}
      />
      <PreviewImage
        imgUrl={previewImage}
        visible={visiblePreview}
        onClose={() => {
          setVisiblePreview(false)
          setPreviewImage(null)
        }}
      />
    </Card>
  )
}
export default HeroPODView
